module.exports = __webpack_public_path__ + "media/images/astro-party-0679177f.svg";